module.exports = __webpack_public_path__ + "img/GeraltUndRoach.8f5f48fa.jpg";